import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
const errorsStr = helpers.error.errors
const mapper = helpers.mapper
const apiModule = api.kontrollers

function getModel () {
  return {
    ID: {
      data: 'ID',
      title: 'ID кресла',
      value: null,
      type: null
    },
    DT: {
      data: 'DT',
      title: 'Дата',
      value: null,
      type: 'datetime',
      order: 'desc',
      showOrder: true
    },
    KOD: {
      data: 'KOD',
      title: 'KOD',
      value: null,
      type: null
    },
    KRNUM: {
      data: 'KRNUM',
      title: 'KRNUM',
      value: null,
      type: null
    },
    NP: {
      data: 'NP',
      title: 'NP',
      value: null,
      type: null
    },
    ORDER: {
      data: 'ORDER',
      title: 'ORDER',
      value: null,
      type: null
    },
    SP: {
      data: 'SP',
      title: 'SP',
      value: null,
      type: null
    },
    TS: {
      data: 'TS',
      title: 'Запись на сервер',
      value: null,
      type: 'datetime',
      order: null,
      showOrder: true
    },
    EVENT_NAME: {
      data: 'EVENT_NAME',
      title: 'Событие',
      value: null,
      type: null,
      handler (data) {
        // return data.EVENT_NAME.replace('$n1', data.KRNUM).replace('$s1', data.SP).replace('$n2', data.NP);
        let d = data.EVENT_NAME.replace('$n1', data.KRNUM).replace('$s1', data.SP)
        if (d.indexOf('мин') > -1) d = d.replace('$n2', data.NP / 60)
        else d = d.replace('$n2', data.NP)
        return d
      }
    }
  }
};

function role () { return localStorage.getItem('role') };

const state = {
  model: getModel(),
  id: null,
  show: 'kontrollers',
  one: getModel(),
  all: [],
  errMain: null,
  errors: {},
  find: [],
  finded: null,
  showFilters: false,
  errors: {},
  filters: {},
  filtersQuery: {},
  isFilter: false,
  tabs: {
    admin: {},
    dealer: {}
  }
}
const getters = {
  getModel (state) { return state.model },
  getId (state) { return state.id },
  getShow (state) { return state.show },
  getOne (state) { return state.one },
  getAll (state) { return state.all },
  getErrors (state) { return state.errors },
  getErrMain (state) { return state.errMain },
  getFind (state) { return state.find },
  getFinded (state) { return state.finded },
  getTabs (state) { return state.tabs[role()] },
  getFilters (state) { return state.filters },
  getFiltersQuery (state) { return state.filtersQuery },
  getShowFilters (state) { return state.showFilters },
  getIsFilter (state) { return state.isFilter }
}
const mutations = {
  setModel (state, data) { state.model = data },
  setId (state, data) { state.id = data },
  setShow (state, data) { state.show = data },
  setOne (state, data) { state.one = data },
  setAll (state, data) { state.all = data },
  setErrors (state, data) { state.errors[data.param] = data.value },
  setErrMain (state, data) { state.errMain = data },
  setFind (state, data) { state.find = data },
  setFinded (state, data) { state.finded = data },
  setTab (state, data) { state.tabs[role()][data.param].active = data.value },
  setFilters (state, data) { state.filters = data },
  setFiltersQuery (state, data) { state.filtersQuery = data },
  resetFiltersQuery (state) { state.filtersQuery = {} },
  setShowFilters (state, data) { state.showFilters = data },
  setIsFilter (state, data) { state.isFilter = data },
  setOrder (state, data) {
    for (let param in state.model) {
      if (state.model[param].order && state.model[param].showOrder && state.model[param] != state.model[data.param]) state.model[param].order = null
    };
    let order = state.model[data.param].order
    if (!order) order = 'desc'
    else if (order == 'desc') order = 'asc'
    else if (order == 'asc') order = null
    state.model[data.param].order = order
  }
}
const actions = {
  setActiveTab ({ commit, state }, data) {
    let param = data.param
    let tabs = state.tabs[role()]
    for (let tab in tabs) {
      if (param == tab) commit('setTab', { param: tab, value: true })
      else commit('setTab', { param: tab, value: false })
    };
  },
  resetAllErr ({ state, commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    if (errors) {
      for (let err in errors) {
        commit('setErrors', { param: err, value: null })
      };
    };
  },
  setModelRequired ({ commit }, data) {
    commit('setModel', mapper.modelRequired(data.required, getModel()))
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  toAdd ({ commit }) {
    commit('setId', null)
    commit('setShow', 'kontroller')
  },
  toUpdate ({ commit }, data) {
    commit('setId', data.id)
    commit('setShow', 'kontroller')
  },
  toAll ({ commit }) {
    commit('setId', null)
    commit('setShow', 'kontrollers')
    commit('setOne', getModel())
  },
  async getOne ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      if (state.id) {
        let result = await httpService.get(apiModule[role()].getOneFullMysql, { idMysql: state.id })
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let order = []
      let model = state.model
      for (let param in model) {
        if (model[param].order) order.push(`${model[param].data},${model[param].order}`)
      };
      data.params.order = order
      let result = await httpService.get(apiModule[role()].getLog, data.params)
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async runFind ({ state, commit, dispatch }, data) {
    try {
      commit('setFinded', null)
      let result = await httpService.get(apiModule[role()].getAllStatusMysql, data.params)
      if (!result && !result.data && !result.data.data) commit('setFind', [])
      let items = result.data.data
      let find = []
      items.forEach(item => {
        find.push(item.KID)
      })
      commit('setFind', find)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getFilters ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(apiModule[role()].getFilters, data.params)
      commit('setFilters', result.data)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async updatePrograms ({ state, commit, dispatch }, data) {
    try {
      let dataMap = data.data
      let dataNew = []
      for (let i = 0; i < dataMap.length; i++) {
        let m = parseInt(dataMap[i].m)
        let r = parseInt(dataMap[i].r)
        if (!m && m != 0) commit('setErrors', { param: `m${i}`, value: errorsStr.empty })
        if (!r && r != 0) commit('setErrors', { param: `r${i}`, value: errorsStr.empty })
        if (m < 0 || m > 31) commit('setErrors', { param: `m${i}`, value: errorsStr.mustBeBetween0And31 })
        if (r < 0) commit('setErrors', { param: `r${i}`, value: errorsStr.lessThanZero })
        let program = {}
        program[`M${i}`] = m
        program[`R${i}`] = r
        dataNew.push(program)
      };
      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      };
      if (isErr) commit('setErrMain', errorsStr.emptyAllCorrect)
      if (!isErr) {
        let result = getModel()
        result = await httpService.patch(apiModule[role()].updatePrograms, { programs: dataNew, idMysql: state.id, isApplyAll: data.isApplyAll })
        commit('setId', result.data.data.KID)
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
        dispatch('resetAllErr')
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
